<template>
  <div class="legal__wrap">
    <Breadcrumb :config="breadcrumb" />
    <div class="m-useful-info layout">
      <div class="m-useful-info__container">
        <div class="m-useful-info__title heading-h2">有用的信息</div>
        <div class="clearfix">
          <div class="m-useful-info__menu-container menu-toggler" @click="clickMenu">
            <div>法律声明</div>
            <span :class="showMenu?'selectboxit-arrow-up':'selectboxit-arrow-down'"></span>
          </div>
          <div class="c-toggler-content" v-if="showMenu">
            <ul class="c-refinement__values">
              <li
                :class="['c-refinement',selected==item.href?'selected':'']"
                v-for="item in menuList"
                :key="item.index"
                @click="clickSelect(item)"
              >
                <span>{{item.name}}</span>
                <span class="checkmark" v-if="selected==item.href">
                  <svg
                    class="svg-inline checkmark"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="15px"
                    height="15px"
                    viewBox="0 0 488.878 488.878"
                    style="enable-background:new 0 0 488.878 488.878;"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <polygon
                          style="fill:#000;"
                          points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298        "
                        />
                      </g>
                    </g>
                  </svg>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="m-useful-info__main-content">
          <article>
            <p>1 个人验证信息</p>
            <p>只有当访问者自愿为本网站提供时，本网站方可收集其姓名、地址、电子邮件等个人验证信息。除非根据法庭或其它政府部门的命令，否则未经您的事先同意，希思黎不会将您的姓名、地址和电子邮件故意提供给第三方。</p>
            <p>2 非个人身份信息</p>
            <p>希思黎希望在您的计算机内安装cookie。Cookie无法让我们了解您的身份。它通常记录与您使用这台计算机浏览本网站有关的信息（您访问过的页面、访问的日期和时间等），以便我们能够在您之后访问时读取。我们向您告知，通过将网络浏览器设置为拒绝安装cookie或在安装这类文件前对您进行提醒，您可以避免cookie记录。我们向访问希思黎网站的用户收集信息，以便更好地了解他们，对其需求和期望做出反馈。我们可能会使用您所提交的信息来与您联络。未经您的明确许可，我们不会向任何第三方分享、或交换任何个人信息。</p>
            <p>3 信息删除</p>
            <p>您可要求本公司从档案中删除与您有关的任何个人身份信息。如需提出此类要求，请写信至希思黎办公室，位于上海市静安区南京西路1539号静安嘉里中心办公楼2座38层，本公司将会核对相关信息后，从档案中删除您的所有信息。</p>
            <p>4 附加信息</p>
            <p>我们无法保证在互联网上传送数据完全安全。希思黎控制范围以外的第三方可能会在未经希思黎许可或知晓的情况下，访问或截取数据传送或私人通讯。希思黎采取一切可能措施保护您的个人信息。但本公司无法确保或担保您向本公司传送的信息安全。这类传送的风险由您自行承担。希思黎对本网站拥有所有权及与之相关的所有权利和利益。希思黎对本网站上的所有资料具备完整知识产权，或已从第三方获得在本网站使用这些资料的有效权限。希思黎还拥有本网站上所使用的所有商标、服务标志、营业名称与图样标志的知识产权。您不得出于商业目的，以任何形式对本网站的任何部分进行拷贝、复制、重新发行、上载、张贴、传送或散布。这项禁令还包括在其它网站上对本网站的内容进行分帧以及未经授权的链接。在未经明确许可的情况下，出于任何目的对这些资料进行修改和使用，将侵犯希思黎的知识产权和其它专属权限。未经希思黎事先书面许可，严禁使用来自本网站的资料。可能会有第三方网站与本网站进行连接。希思黎并不认可这类网站或这类网站所提供的商品或服务。希思黎对这类网站提供的信息准确性以及这类网站所提供或从这类网站购买的商品或服务概不负责。希思黎无需对与与本网站连接的网站内容承担任何法律责任。</p>
            <p>5 信息准确性</p>
            <p>希思黎无法绝对保证，但将采取一切可能的措施，确保本网站所包含信息的准确性和及时性。但是，本网站所提供的信息可在任何时间进行修订且无事先预告。希思黎集团为根据法国法律注册成立的股份有限公司，股份资本为100万欧元，注册编号为RCS PARIS B 722 003 464，注册地址为法国巴黎乔治五世大街16号（邮编：75008），电话：+33 (0) 1 49 52 35 00，为希思黎网站的发布者。</p>
            <p>多媒体经理：Hélène Hallaf</p>
          </article>
        </div>
      </div>
      <div></div>
    </div>
    <!-- h5 -->
    <div class="m-refinements__refinement-bar m-useful-info__menu-mobile" v-if="showMenu">
      <div class="m-refinements__filter-header m-useful-info-bar-open">
        <div class="m-refinements__close-btn clearfix">
          <button class="c-button c-button--rounded float-right close" @click="showMenu=false">
            <svg
              class="svg-inline cross"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="12px"
              height="12px"
              viewBox="0 0 612 612"
              style="enable-background:new 0 0 612 612;"
              xml:space="preserve"
            >
              <g>
                <g id="cross">
                  <g>
                    <polygon
                      points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </div>
      <div class="m-refinements__list clearfix">
        <div class="c-refinement c-toggler c-toggler--expanded">
          <a
            href="#"
            class="c-refinement__header c-toggler__title"
            @click="hideMenu=!hideMenu"
          >有用的信息</a>
          <div :class="['c-refinement__body',hideMenu?'c-toggler__content':'']">
            <ul class="c-refinement__values">
              <li
                title="销售条款"
                class="c-refinement__value"
                v-for="item in menuList"
                :key="item.name"
              >
                <a
                  :href="item.href"
                  :class="['c-refinement__value-link', selected==item.href?'selected':'']"
                >
                  <span class="c-refinement__value-link-name m-useful-info__menu-link">{{item.name}}</span>

                  <svg
                    v-if="selected==item.href"
                    class="svg-inline checkmark"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="15px"
                    height="15px"
                    viewBox="0 0 488.878 488.878"
                    style="enable-background:new 0 0 488.878 488.878;"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <polygon
                          style="fill:#000;"
                          points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298        "
                        />
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="m-refinements__apply-btn m-useful-info-bar-open">
        <button class="c-button c-button--secondary c-button--expand" @click="showMenu=false">应用</button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "LegalStatement",
  components: { Breadcrumb },
  data() {
    return {
      breadcrumb: {
        items: [{ text: "法律声明", href: "" }]
      },
      showMenu: false,
      hideMenu: false,
      menuList: [
        { name: "法律声明", href: "/legal" },
        { name: "条款与条件", href: "/terms" },
        { name: "隐私条款", href: "/privacy" },
      ],
      selected: "",
    };
  },
  mounted() {
    if (this.$route.path) {
      this.selected = this.$route.path;
    }
  },
  methods: {
    clickMenu() {
      this.showMenu = !this.showMenu;
    },
    clickSelect(item) {
      this.showMenu = !this.showMenu;
      this.$router.push({ path: item.href });
    },
  },
};
</script>

<style lang="scss" scoped>
.m-useful-info { padding: 0 1.0625rem 3.75rem; }
.m-useful-info__container { padding: 3.125rem 0 0; }
.m-useful-info__title { text-align: center; font-size: 1.5265rem; margin-bottom: 1.875rem; }
.m-useful-info__menu-container { margin-bottom: 1.875rem; }
.menu-toggler {
  color: #000;
  line-height: 1.2;
  padding: 0.75rem 3.9375rem 0.75rem 2.0625rem;
  position: relative;
  cursor: pointer;
  border: 0.0625rem solid #cacaca;
  border-radius: 1.375rem;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
}
.c-toggler-content { display: none; }

.small { display: block; font-size: 10px; text-decoration: none; }
.article { padding-top: 70px; margin-top: -70px; }
.selectboxit-arrow-down, .selectboxit-arrow-up {
  display: block;
  width: 0.625rem;
  height: 0.625rem;
  background-image: url("../assets/imgs/icons/arrow.svg");
  background-repeat: no-repeat;
  background-position: 50%;
  position: absolute;
  right: 1.875rem;
}
.selectboxit-arrow-down { transform: rotateX(180deg); }
.selectboxit-arrow-up { transform: rotateX(0deg); }
.m-refinements__refinement-bar {
  position: fixed;
  right: 0;
  top: 0;
  transition: right 0.3s linear;
  background-color: #fff;
  height: 100%;
  width: 80%;
  z-index: 11;
}
.m-refinements__close-btn { padding: 1.5625rem 1.125rem 0.625rem 0; }
.c-toggler__title {
  position: relative;
  cursor: pointer;
  border-top: 0.0625rem solid #dfdfdf;
  border-bottom: 0.0625rem solid #dfdfdf;
  padding: 0.9375rem 0;
  margin-bottom: 0;
  display: block;
}
.c-refinement__header {
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.75rem;
  color: #000;
  border-top: none;
  padding: 1.5625rem 3.9375rem 1.5625rem 2.0625rem;
  text-decoration: none;
  display: block;
}
.c-refinement__body { background-color: #f5f5f5; padding: 0.9375rem 2.0625rem; }

.c-toggler__title:after {
  content: "";
  background: url("../assets/imgs/icons/arrow.svg") no-repeat;
  width: 0.9375rem;
  height: 0.5rem;
  right: 1.875rem;
  background-size: contain;
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateY(-0.5px);
}

.c-refinement__value-link {
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.75rem;
  color: #000;
  text-decoration: none;
  display: block;
  padding: 0.625rem 0 0.625rem 1.875rem;
}
.c-refinement__value-link.selected { text-decoration: underline; padding-left: 0; }
.c-refinement__value-link.selected .checkmark { float: left; margin: 0.125rem 0.9375rem 0 0; }
.m-refinements__apply-btn { padding: 2.5rem 2.0625rem 7.8125rem; }
.m-refinements__apply-btn .c-button { font-size: 0.625rem; font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif; padding: 0.8125rem 1.875rem; }
.c-button--expand { display: block; width: 100%; margin-right: 0; margin-left: 0; max-width: 100%; }
.c-button--secondary, .order-tracking-popin .c-order__cancel-wrapper .c-button--primary-reversed {
  display: inline-block;
  vertical-align: middle;
  padding: 0.8125rem 1.875rem;
  -webkit-appearance: none;
  border-radius: 1.375rem;
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
  font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
  font-size: 0.625rem;
  line-height: 1;
  letter-spacing: 0.0625rem;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  background: transparent;
  border: 0.0625rem solid #cacaca;
  color: #000;
}
.c-toggler__content { display: none; }
@media screen and (max-width: 63.9375em) {
  .m-refinements__list { overflow-y: auto; height: calc(100vh - 276px); }
}
@media screen and (min-width: 48em) {
  .m-useful-info { padding: 0 3.875rem 3.75rem; }
  .m-refinements__refinement-bar { display: none;  }
  .c-refinement {
    min-width: 13.4375rem;
    font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
    font-size: 0.75rem;
    color: #000;
    text-decoration: none;
    display: block;
    padding: 0.6875rem 1.25rem 0.6875rem 0.6875rem;
    cursor: pointer;
    border-radius: 0.5rem;
    &.selected { background-color: #f5f5f5; text-decoration: underline; }
  }
  .m-useful-info__title { text-align: left; float: left; }
  .m-useful-info__menu-container { float: right; }
  .c-toggler-content {
    display: block;
    position: absolute;
    z-index: 1;
    margin-top: 2.625rem;
    border-radius: 0.625rem;
    box-shadow: 0 0.3125rem 0.4375rem 0 hsla(0, 0%, 87.5%, 0.5);
    background-color: #fff;
    padding: 0.4375rem 0.5rem 0.5rem;
    right: 4rem;
  }
  .checkmark { float: right; }
}
@media screen and (min-width: 64em) {
  .breadcrumb { padding: 0 1.875rem; }
  .m-useful-info { padding: 0 1.875rem 3.75rem; }
  .m-useful-info__container { padding: 2.1875rem 6.25rem 0; }
  .m-useful-info__title { margin-bottom: 3.4375rem; }
  .m-useful-info__menu-container { margin-bottom: 3.4375rem; }
  .menu-toggler {
    border: 0.0625rem solid #cacaca; border-radius: 1.375rem; background-color: #fff;
    &:hover { background-color: #f5f5f5; }
  }
  .c-refinement {
    min-width: 14.6875rem;
    color: #575757;
    margin-top: 0.0625rem;
    border-radius: 0.5rem;
    min-width: 13.4375rem;
    white-space: nowrap;
    padding: 0.6875rem 1.25rem 0.6875rem 0.6875rem;
    &.selected { background-color: #f5f5f5; text-decoration: none; padding-left: 0.6875rem; }
  }
  .c-toggler-content { right: 7rem; }
}
@media screen and (min-width: 75em) {
  .m-useful-info { padding: 0 0 5rem; }
  .m-useful-info__container { padding: 2.1875rem 12.5rem 0; }
}
</style>